import * as React from 'react';

import { Grid } from '@emburse/ui-core';

import { DatePickerEmbark } from '@ReactComponents/Shared/DatePicker/DatePickerEmbark';

interface ICancellableDateRangeProps {
  includeStartDate?: boolean;
  includeEndDate?: boolean;
  startDate: Date | null;
  endDate: Date | null;
  onStartChange: (val: Date | null) => void;
  onEndChange: (val: Date | null) => void;
}

export const CancellableDateRange: React.FC<ICancellableDateRangeProps> = ({
  includeStartDate,
  includeEndDate,
  startDate,
  endDate,
  onStartChange,
  onEndChange
}) => {
  const renderStartDate = () => (
    <DatePickerEmbark
      id="startDate"
      label="Start Date"
      value={startDate}
      onChange={onStartChange}
      showClearDate
      disablePast
      closeOnSelect
      maxDate={(includeEndDate && endDate) || undefined}
    />
  );

  const renderEndDate = () => (
    <DatePickerEmbark
      id="endDate"
      label="End Date"
      value={endDate}
      onChange={onEndChange}
      showClearDate
      disablePast
      closeOnSelect
      minDate={(includeStartDate && startDate) || undefined}
    />
  );

  return (
    <>
      {includeStartDate && (
        <Grid item xs={6}>
          {renderStartDate()}
        </Grid>
      )}
      {includeEndDate && (
        <Grid className="endDatePicker" item xs={6}>
          {renderEndDate()}
        </Grid>
      )}
    </>
  );
};
